import { ROUTES } from "const";
import { CourseHelper } from "libs/helpers";

export class TFACLASSICO_UNICAMILLUS {

  static async getDashboardCards(courseCode, registrationCode) {

    const cards = [{
      title: "Messaggi",
      link: ROUTES.COURSE_TICKETS,
      img: "/img/icon/message.png",
      className: "image-box",
    }, {
      title: "Situazione pagamenti",
      link: ROUTES.MU_COURSE_PAYMENTS,
      img: "/img/icon/payment.png",
      className: "image-box",
    }, {
      title: "Badge Accesso Aula",
      link: ROUTES.MY_BADGE,
      img: "/img/icon/1.png",
      className: "image-box",
    }
    ];

    if (!CourseHelper.isTFAAbbreviato(courseCode)) {
      cards.push({
        title: "Insegnamenti",
        link: ROUTES.COURSE_LESSON_SCHEDULE_ALL,
        img: "/img/icon/presentation.png",
        className: "image-box",
      });
    }

    cards.push({
      title: "Laboratori",
      link: ROUTES.COURSE_LESSONTRAINING_SCHEDULE + "/laboratorio",
      img: "/img/icon/presentation.png",
      className: "image-box",
    });

    cards.push({
      title: "Tirocinio Indiretto",
      link: ROUTES.COURSE_LESSONTRAINING_SCHEDULE + "/tirocinio",
      img: "/img/icon/8.webp",
      className: "image-box",
    });

    cards.push({
      title: "Nuove tecnologie per l'apprendimento - TIC",
      link: ROUTES.COURSE_LESSONTRAINING_SCHEDULE + "/tic",
      img: "/img/icon/8.webp",
      className: "image-box",
    });

    cards.push({
      title: "Tirocinio diretto",
      link: ROUTES.COURSE_TIROCINIODIRETTOTFACLASSICO_DETAIL,
      img: "/img/icon/8.webp",
      className: "image-box",
    });

    cards.push({
      title: "Consultazione esiti",
      link: ROUTES.COURSE_MODULES_TFACLASSICO,
      img: "/img/icon/examdone.png",
      className: "image-box",
    });

    return cards;
  }

  static getDashboardNotices(courseCode, registrationCode) {

    let urlCalendario = '';
    if (this.isTFAPA(courseCode)) {
      if (CourseHelper.isTFAAbbreviato(courseCode)) {
        urlCalendario = "calendario-tfapa-abbreviato.pdf";
      } else {
        urlCalendario = "calendario-tfapa-regolare.pdf";
      }
    } else if (this.isTFAVE(courseCode)) {
      if (CourseHelper.isTFAAbbreviato(courseCode)) {
        urlCalendario = "calendario-tfave-abbreviato.pdf";
      } else {
        urlCalendario = "calendario-tfave-regolare.pdf";
      }
    }


    urlCalendario = 'https://www.formazionedocenti.it/files/corsi/tfa-classico/' + urlCalendario;

    let notices = [];

    if (!CourseHelper.isTFAAbbreviato(courseCode)) {

      let linkCalendarioEsami = '';
      if (this.isTFAPA(courseCode)) {
        linkCalendarioEsami = 'https://www.formazionedocenti.it/files/corsi/tfa-classico/calendario_esami_insegnamenti_tfapa.pdf';
      } else if (this.isTFAVE(courseCode)) {
        linkCalendarioEsami = 'https://www.formazionedocenti.it/files/corsi/tfa-classico/calendario_esami_insegnamenti_tfave.pdf';
      }

      notices.push({
        title: `Linee guida nuove Tecnologie per l'apprendimento (T.I.C.) `,
        content: `<a href="https://www.formazionedocenti.it/files/corsi/tfa-classico/linee_guida_tic.pdf" target="_blank">Clicca qui per scaricare le linee guida</a>`,
      });

      notices.push({
        title: `Avviso Prove di Valutazione "Insegnamenti" `,
        content: `<a href="${linkCalendarioEsami}" target="_blank">Clicca qui per scaricare l'Avviso</a>`,
      });

      notices.push({
        title: `Linee guida Insegnamenti erogati in modalità telematica`,
        content: `<a href="https://www.formazionedocenti.it/files/corsi/tfa-classico/linee_guida_insegnamenti.pdf" target="_blank">Clicca qui per scaricare le linee guida</a>`,
      });
    }

    notices.push({
      title: `Calendario Attività didattiche`,
      content: `<a href="${urlCalendario}" target="_blank">Clicca qui per scaricare il calendario</a>`,
    });

    return notices;
  }

  static isTFAPA(courseCode) {
    return courseCode.includes("TFAPA");
  }

  static isTFAVE(courseCode) {
    return courseCode.includes("TFAVE");
  }
}
